<template>
  <div
    class="modal fade"
    id="hcpModal"
    data-focus="false"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-scrollable modal-lg">
      <div class="modal-content">
        <ValidationObserver v-slot="{ handleSubmit }">
          <div class="modal-header">
            <h5 class="modal-title">HCP 人事資料維護</h5>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">員工編號</label>
                  <el-input
                    type="text"
                    clearable
                    maxlength="10"
                    show-word-limit
                    placeholder="請輸入"
                    v-model.trim="hcp.EmployeeNo"
                  />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">英文姓名</label>
                  <el-input
                    type="text"
                    clearable
                    maxlength="50"
                    show-word-limit
                    placeholder="請輸入"
                    v-model.trim="hcp.EnglishName"
                  />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">Plant</label>
                  <el-select
                    class="w-100"
                    filterable
                    allow-create
                    clearable
                    value-key="Guid"
                    placeholder="請選擇"
                    @change="
                      (deptOptions = []), (hcp.EmployeeDepartment = null)
                    "
                    v-model="hcp.EmployeePlant"
                  >
                    <el-option
                      v-for="plant in plantOptions"
                      :key="plant.Guid"
                      :label="plant.Name"
                      :value="plant"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">所在部門</label>
                  <el-select
                    class="w-100"
                    filterable
                    clearable
                    allow-create
                    value-key="Guid"
                    placeholder="請先選擇 Plant"
                    v-model="hcp.EmployeeDepartment"
                  >
                    <el-option
                      v-for="dept in deptOptions"
                      :key="dept.Guid"
                      :label="dept.Name"
                      :value="dept"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">部門代碼</label>
                  <el-input
                    type="text"
                    clearable
                    maxlength="10"
                    show-word-limit
                    placeholder="請輸入"
                    v-model.trim="hcp.EmployeeGroupCode"
                  />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">刷卡卡別</label>
                  <el-input
                    type="text"
                    clearable
                    maxlength="10"
                    show-word-limit
                    placeholder="請輸入"
                    v-model.trim="hcp.CardType"
                  />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">年假代號</label>
                  <el-input
                    type="text"
                    clearable
                    maxlength="10"
                    show-word-limit
                    placeholder="請輸入"
                    v-model.trim="hcp.AnnualLeaveCode"
                  />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">員工分類(代號)</label>
                  <el-input
                    type="text"
                    clearable
                    maxlength="10"
                    show-word-limit
                    placeholder="請輸入"
                    v-model.trim="hcp.EmployeeTypeCode"
                  />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">銀行代碼</label>
                  <el-select
                    class="w-100"
                    clearable
                    placeholder="請選擇"
                    v-model="hcp.BankCode"
                  >
                    <el-option label="郵局(700)" value="700"></el-option>
                    <el-option label="中國信託(822)" value="822"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">銀行帳號</label>
                  <el-input
                    type="text"
                    clearable
                    maxlength="20"
                    show-word-limit
                    placeholder="請輸入"
                    v-model.trim="hcp.BankAccount"
                  />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">稅別</label>
                  <el-input
                    type="text"
                    clearable
                    maxlength="10"
                    show-word-limit
                    placeholder="請輸入"
                    v-model.trim="hcp.TaxCategoryCode"
                  />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">職稱類別</label>
                  <el-select
                    class="w-100"
                    clearable
                    placeholder="請選擇"
                    v-model="hcp.JobTitleCode"
                  >
                    <el-option label="管理職" value="管理職"></el-option>
                    <el-option label="技術職" value="技術職"></el-option>
                    <el-option label="事務職" value="事務職"></el-option>
                    <el-option label="技能職" value="技能職"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">是否為外籍配偶</label>
                  <el-select
                    class="w-100"
                    clearable
                    placeholder="請選擇"
                    v-model="hcp.ForeignSpouseType"
                  >
                    <el-option label="外籍配偶" value="外籍配偶"></el-option>
                    <el-option label="大陸配偶" value="大陸配偶"></el-option>
                    <el-option label="長期居留" value="長期居留"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">考勤卡號</label>
                  <el-input
                    type="text"
                    clearable
                    maxlength="10"
                    show-word-limit
                    placeholder="請輸入"
                    v-model.trim="hcp.CardNo"
                  />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">聘僱類別</label>
                  <el-select
                    class="w-100"
                    clearable
                    placeholder="請選擇"
                    v-model="hcp.EmploymentType"
                  >
                    <el-option label="藍領" value="藍領"></el-option>
                    <el-option label="白領" value="白領"></el-option>
                    <el-option label="產學合作" value="產學合作"></el-option>
                    <el-option label="部份工時" value="部份工時"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">身份別</label>
                  <el-select
                    class="w-100"
                    clearable
                    placeholder="請選擇"
                    v-model="hcp.IdentityType"
                  >
                    <el-option label="IDL" value="IDL" />
                    <el-option label="IDL工讀生" value="IDL工讀生" />
                    <el-option label="DL" value="DL" />
                    <el-option label="按摩師" value="按摩師" />
                    <el-option
                      label="DL產學合作4+2產學生(高中畢業)"
                      value="DL產學合作4+2產學生(高中畢業)"
                    />
                    <el-option
                      label="DL產學合作1年期實習生(大四學生)"
                      value="DL產學合作1年期實習生(大四學生)"
                    />
                    <el-option label="外籍" value="外籍" />
                  </el-select>
                </div>
              </div>

              <div class="col-md-6 col-sm-12">
                <label for="">身份類型</label>
                <div class="form-group radio-style">
                  <input
                    id="IdentityClass1"
                    type="radio"
                    value="身份證"
                    :disabled="!$Permission.Appointment.DLPermission.IsValid"
                    @click="
                      hcp.IdentityClass ? (hcp.IdentityClass = null) : '身份證'
                    "
                    v-model="hcp.IdentityClass"
                  />
                  <label class="mr-4" for="IdentityClass1">身份證</label>
                  <input
                    id="IdentityClass2"
                    type="radio"
                    value="護照居留證號"
                    :disabled="!$Permission.Appointment.DLPermission.IsValid"
                    @click="
                      hcp.IdentityClass
                        ? (hcp.IdentityClass = null)
                        : '護照居留證號'
                    "
                    v-model="hcp.IdentityClass"
                  />
                  <label for="IdentityClass2">護照/居留證號</label>
                </div>
              </div>

              <div class="col-md-6 col-sm-12">
                <label for="">錄用類型</label>
                <div class="form-group radio-style">
                  <input
                    id="EmployCategory1"
                    type="radio"
                    value="新人錄用"
                    v-model="hcp.EmployCategory"
                    @click="
                      hcp.EmployCategory
                        ? (hcp.EmployCategory = null)
                        : '新人錄用'
                    "
                  />
                  <label class="mr-4" for="EmployCategory1">新人錄用</label>
                  <input
                    id="EmployCategory2"
                    type="radio"
                    value="老人回廠/舊年資併計"
                    v-model="hcp.EmployCategory"
                    @click="
                      hcp.EmployCategory
                        ? (hcp.EmployCategory = null)
                        : '老人回廠/舊年資併計'
                    "
                  />
                  <label for="EmployCategory2">老人回廠／舊年資併計</label>
                  <br/>
                  <input
                    id="EmployCategory3"
                    type="radio"
                    value="老人回廠/新人錄用"
                    v-model="hcp.EmployCategory"
                    @click="
                      hcp.EmployCategory
                        ? (hcp.EmployCategory = null)
                        : '老人回廠/新人錄用'
                    "
                  />
                  <label for="EmployCategory2">老人回廠／新人錄用</label>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">任用部門</label>
                  <treeselect
                    :options="departmentOptions"
                    :show-count="true"
                    :default-expand-level="1"
                    placeholder="請選擇"
                    v-model="hcp.AppointmentDepartmentGuid"
                  />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">聘僱期間(起)</label>
                  <el-date-picker
                    class="w-100"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="請選擇"
                    v-model="hcp.EmploymentStart"
                  />
                </div>
              </div>

              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">聘僱期間(迄)</label>
                  <ValidationProvider
                    class="w-100"
                    name="聘僱期間(迄)"
                    :rules="{
                      notBeforeStartDate: hcp.EmploymentStart,
                    }"
                    v-slot="{ errors }"
                  >
                    <el-date-picker
                      class="w-100"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="請選擇"
                      v-model="hcp.EmploymentEnd"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">職等</label>
                  <el-select
                    :disabled="!$Permission.Appointment.DLPermission.IsValid"
                    class="w-100"
                    clearable
                    placeholder="請選擇"
                    v-model="hcp.Rank"
                  >
                    <el-option label="1" value="1" />
                    <el-option label="2" value="2" />
                    <el-option label="2.1" value="2.1" />
                    <el-option label="2.2" value="2.2" />
                    <el-option label="3" value="3" />
                    <el-option label="4" value="4" />
                    <el-option label="5" value="5" />
                    <el-option label="6" value="6" />
                    <el-option label="6.3" value="6.3" />
                    <el-option label="7" value="7" />
                    <el-option label="7.3" value="7.3" />
                    <el-option label="8" value="8" />
                    <el-option label="8.3" value="8.3" />
                    <el-option label="9" value="9" />
                    <el-option label="9.3" value="9.3" />
                    <el-option label="10" value="10" />
                    <el-option label="10.3" value="10.3" />
                    <el-option label="10.5" value="10.5" />
                    <el-option label="10.7" value="10.7" />
                    <el-option label="11" value="11" />
                    <el-option label="11.3" value="11.3" />
                    <el-option label="11.5" value="11.5" />
                    <el-option label="12" value="12" />
                    <el-option label="13" value="13" />
                    <el-option label="13.3" value="13.3" />
                  </el-select>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">任用職稱</label>
                  <el-select
                    :disabled="!$Permission.Appointment.DLPermission.IsValid"
                    class="w-100"
                    clearable
                    placeholder="請選擇"
                    v-model="hcp.AppointmentPosition"
                  >
                    <el-option label="生產助理員" value="生產助理員" />
                    <el-option label="助理" value="助理" />
                    <el-option label="技術助理員" value="技術助理員" />
                    <el-option label="技術員" value="技術員" />
                    <el-option label="高級技術員" value="高級技術員" />
                    <el-option label="事務員" value="事務員" />
                    <el-option label="資深技術員" value="資深技術員" />
                    <el-option label="組長" value="組長" />
                    <el-option label="儲備組長" value="儲備組長" />
                    <el-option label="工讀生" value="工讀生" />
                    <el-option label="實習生" value="實習生" />
                    <el-option label="按摩師" value="按摩師" />
                  </el-select>
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <label for="">工作時間</label>
                <div class="form-group radio-style">
                  <input
                    id="WorkTimeType1"
                    type="radio"
                    value="一般工時"
                    v-model="hcp.WorkTimeType"
                    @click="
                      hcp.WorkTimeType ? (hcp.WorkTimeType = null) : '一般工時'
                    "
                  />
                  <label class="mr-4" for="WorkTimeType1">一般工時</label>
                  <input
                    id="WorkTimeType2"
                    type="radio"
                    value="特殊工時"
                    v-model="hcp.WorkTimeType"
                    @click="
                      hcp.WorkTimeType ? (hcp.WorkTimeType = null) : '特殊工時'
                    "
                  />
                  <label for="WorkTimeType2">特殊工時</label>
                </div>
              </div>
              <div
                v-if="hcp.WorkTimeType === '一般工時'"
                class="col-md-6 col-sm-12"
              >
                <div class="form-group">
                  <label for="">班別</label>
                  <el-select
                    class="w-100"
                    filterable
                    clearable
                    placeholder="請選擇"
                    @change="changeWorkShift"
                    v-model="hcp.WorkShiftTypeGuid"
                  >
                    <el-option
                      v-for="shift in shiftOptions"
                      :key="shift.Guid"
                      :label="shift.Name"
                      :value="shift.Guid"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <template
                v-if="
                  hcp.WorkShiftTypeGuid ===
                  '11111111-1111-1111-1111-111111111111'
                "
              >
                <div class="col-md-6 col-sm-12">
                  <div class="form-group">
                    <label for="">班別描述</label>
                    <el-input
                      clearable
                      maxlength="20"
                      v-model.trim="hcp.WorkShiftTypeDesc"
                    />
                  </div>
                </div>
                <div class="col-md-6 col-sm-12">
                  <div class="form-group">
                    <label for="">休息分鐘數</label>
                    <el-input-number
                      style="width: 100%"
                      :min="0"
                      :max="999"
                      :step="1"
                      :precision="0"
                      v-model="hcp.BreakMinute"
                    />
                  </div>
                </div>
                <div class="col-md-6 col-sm-12">
                  <div class="form-group">
                    <label for="">每日工時</label>
                    <el-input-number
                      style="width: 100%"
                      :min="0"
                      :max="24"
                      :step="1"
                      :precision="0"
                      v-model="hcp.DailyWorkHour"
                    />
                  </div>
                </div>
                <div class="col-md-6 col-sm-12">
                  <div class="form-group">
                    <label for="">每週工時</label>
                    <el-input-number
                      style="width: 100%"
                      :min="0"
                      :max="168"
                      :step="1"
                      :precision="0"
                      v-model="hcp.WeeklyWorkHour"
                    />
                  </div>
                </div>
              </template>

              <div
                v-if="hcp.WorkTimeType === '特殊工時'"
                class="col-md-6 col-sm-12"
              >
                <label for="">特殊出勤類型</label>
                <div class="form-group radio-style">
                  <input
                    id="SpecialWork1"
                    type="radio"
                    value="週一至週五"
                    @click="
                      hcp.SpecialWorkTimeType
                        ? (hcp.SpecialWorkTimeType = null)
                        : '週一至週五'
                    "
                    v-model="hcp.SpecialWorkTimeType"
                  />
                  <label class="mr-4" for="SpecialWork1">週一至週五</label>
                  <input
                    id="SpecialWork2"
                    type="radio"
                    value="約定工時"
                    @click="
                      hcp.SpecialWorkTimeType
                        ? (hcp.SpecialWorkTimeType = null)
                        : '約定工時'
                    "
                    v-model="hcp.SpecialWorkTimeType"
                  />
                  <label for="SpecialWork2">約定工時</label>
                </div>
              </div>

              <template
                v-if="
                  hcp.WorkTimeType === '特殊工時' &&
                  hcp.SpecialWorkTimeType === '約定工時'
                "
              >
                <div class="col-md-6 col-sm-12">
                  <div class="form-group">
                    <label for="">約定週工時</label>
                    <el-input-number
                      style="width: 100%"
                      :min="0"
                      :max="168"
                      :step="1"
                      :precision="0"
                      v-model="hcp.SpecialWeeklyHour"
                    />
                  </div>
                </div>
                <div class="col-md-6 col-sm-12">
                  <div class="form-group">
                    <label for="">約定月工時</label>
                    <el-input-number
                      style="width: 100%"
                      :min="0"
                      :max="744"
                      :step="1"
                      :precision="0"
                      v-model="hcp.SpecialMonthlyHour"
                    />
                  </div>
                </div>
              </template>

              <div class="col-md-6 col-sm-12">
                <label for="">薪制</label>
                <div class="form-group radio-style">
                  <input
                    id="SalaryType1"
                    type="radio"
                    value="時薪"
                    v-model="hcp.SalaryType"
                    @click="hcp.SalaryType ? (hcp.SalaryType = null) : '時薪'"
                  />
                  <label class="mr-4" for="SalaryType1">時薪</label>
                  <input
                    id="SalaryType2"
                    type="radio"
                    value="月薪"
                    v-model="hcp.SalaryType"
                    @click="hcp.SalaryType ? (hcp.SalaryType = null) : '月薪'"
                  />
                  <label for="SalaryType2">月薪</label>
                </div>
              </div>
              <div v-if="hcp.SalaryType === '月薪'" class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">底薪</label>
                  <ValidationProvider
                    class="w-100"
                    name="底薪"
                    :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                    v-slot="{ errors }"
                  >
                    <input
                      :disabled="!$Permission.Appointment.DLPermission.IsValid"
                      type="text"
                      class="form-control w-100"
                      v-model.trim="hcp.BasicSalary"
                    />
                    <span v-if="errors" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>
              <div v-if="hcp.SalaryType === '時薪'" class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">時薪</label>
                  <ValidationProvider
                    class="w-100"
                    name="時薪"
                    :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      class="form-control w-100"
                      v-model.trim="hcp.HourSalary"
                    />
                    <span v-if="errors" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>
              <div v-if="hcp.SalaryType === '月薪'" class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">交通津貼</label>
                  <ValidationProvider
                    class="w-100"
                    name="交通津貼"
                    :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      class="form-control w-100"
                      :disabled="!$Permission.Appointment.DLPermission.IsValid"
                      v-model.trim="hcp.TransportationAllowance"
                    />
                    <span v-if="errors" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>

              <div v-if="hcp.SalaryType === '月薪'" class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">班次津貼</label>
                  <ValidationProvider
                    class="w-100"
                    name="班次津貼"
                    :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      class="form-control w-100"
                      :disabled="!$Permission.Appointment.DLPermission.IsValid"
                      v-model.trim="hcp.ShiftAllowance"
                    />
                    <span v-if="errors" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>

              <div v-if="hcp.SalaryType === '月薪'" class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">勤工營養金</label>
                  <ValidationProvider
                    class="w-100"
                    name="勤工營養金"
                    :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      class="form-control w-100"
                      :disabled="!$Permission.Appointment.DLPermission.IsValid"
                      v-model.trim="hcp.PerfectAttendanceBonus"
                    />
                    <span v-if="errors" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>

              <div v-if="hcp.SalaryType === '月薪'" class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">伙食</label>
                  <el-input
                    type="text"
                    clearable
                    maxlength="20"
                    :disabled="!$Permission.Appointment.DLPermission.IsValid"
                    placeholder="請輸入"
                    v-model.trim="hcp.Food"
                  />
                </div>
              </div>

              <div v-if="hcp.SalaryType === '月薪'" class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">其他津貼名稱</label>
                  <el-input
                    type="text"
                    clearable
                    maxlength="20"
                    placeholder="請輸入"
                    v-model.trim="hcp.OtherAllowanceName"
                  />
                </div>
              </div>

              <div
                v-if="hcp.SalaryType === '月薪' && hcp.OtherAllowanceName"
                class="col-md-6 col-sm-12"
              >
                <div class="form-group">
                  <label for="">其他津貼</label>
                  <ValidationProvider
                    class="w-100"
                    name="其他津貼"
                    :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      class="form-control w-100"
                      v-model.trim="hcp.OtherAllowance"
                    />
                    <span v-if="errors" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">聘僱期間福利</label>
                  <el-select
                    class="w-100"
                    clearable
                    placeholder="請選擇"
                    v-model="hcp.BenefitType"
                  >
                    <el-option label="不發放三節獎金" value="不發放三節獎金" />
                    <el-option label="按比例發放三節" value="按比例發放三節" />
                    <el-option
                      label="與正式人員同福利"
                      value="與正式人員同福利"
                    />
                    <el-option label="其他" value="其他" />
                  </el-select>
                </div>
              </div>

              <div
                class="col-md-6 col-sm-12"
                v-if="hcp.BenefitType === '按比例發放三節'"
              >
                <div class="form-group">
                  <label for="">三節須年滿天數</label>
                  <el-input-number
                    style="width: 100%"
                    :min="0"
                    :max="999"
                    :step="1"
                    :precision="0"
                    v-model="hcp.HolidayBonusRequiredDay"
                  />
                </div>
              </div>

              <div
                class="col-md-12 col-sm-12"
                v-if="hcp.BenefitType === '其他'"
              >
                <div class="form-group">
                  <label for="">福利說明</label>
                  <el-input
                    type="textarea"
                    :rows="3"
                    show-word-limit
                    maxlength="100"
                    v-model.trim="hcp.BenefitOtherDesc"
                  />
                </div>
              </div>

              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">加班計薪類型</label>
                  <el-select
                    class="w-100"
                    clearable
                    placeholder="請選擇"
                    v-model.trim="hcp.OverTimeType"
                  >
                    <el-option
                      label="依照各類班制之規定辦理"
                      value="依照各類班制之規定辦理"
                    />
                    <el-option label="依照人事政策" value="依照人事政策" />
                    <el-option
                      label="依照實際工作時數"
                      value="依照實際工作時數"
                    />
                  </el-select>
                </div>
              </div>

              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label for="">試用期月數</label>
                  <el-input-number
                    style="width: 100%"
                    :min="0"
                    :max="99"
                    :precision="0"
                    v-model="hcp.ProbationMonth"
                  />
                </div>
              </div>

              <div class="col-md-6 col-sm-12">
                <label for="">是否進訓</label>
                <div class="form-group radio-style">
                  <input
                    id="IsNeedTraining1"
                    type="radio"
                    value="true"
                    v-model="hcp.IsNeedTraining"
                    @click="
                      hcp.IsNeedTraining ? (hcp.IsNeedTraining = null) : 'true'
                    "
                  />
                  <label class="mr-4" for="IsNeedTraining1">是</label>
                  <input
                    id="IsNeedTraining2"
                    type="radio"
                    value="false"
                    v-model="hcp.IsNeedTraining"
                    @click="
                      hcp.IsNeedTraining ? (hcp.IsNeedTraining = null) : 'false'
                    "
                  />
                  <label for="IsNeedTraining2">否</label>
                </div>
              </div>

              <div class="col-md-12 col-sm-12">
                <div class="form-group">
                  <label for="">備註</label>
                  <el-input
                    type="textarea"
                    clearable
                    :rows="2"
                    maxlength="100"
                    show-word-limit
                    placeholder="請輸入"
                    v-model.trim="hcp.Remark"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">
              關閉
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="handleSubmit(saveHcp)"
            >
              儲存
            </button>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapGetters, mapActions } from "vuex";

export default {
  props: ["personData"],

  name: "HcpModal",
  data() {
    return {
      hcp: {
        Food: "",
        PerfectAttendanceBonus: "",
        ShiftAllowance: "",
        TransportationAllowance: "",
        OtherAllowanceName: "",
        OtherAllowance: "",
      },

      departmentOptions: [],
      plantOptions: [],
      deptOptions: [],
      shiftOptions: [],
      shiftSources: [],
    };
  },

  methods: {
    // 儲存 HCP人事資料欄位
    saveHcp() {
      let EmployeePlant, EmployeeDepartment;
      if (typeof this.hcp.EmployeePlant === "string") {
        EmployeePlant = {
          Guid: null,
          Name: this.hcp.EmployeePlant,
        };
      } else {
        EmployeePlant = this.hcp.EmployeePlant;
      }
      if (typeof this.hcp.EmployeeDepartment === "string") {
        EmployeeDepartment = {
          Guid: null,
          Name: this.hcp.EmployeeDepartment,
        };
      } else {
        EmployeeDepartment = this.hcp.EmployeeDepartment;
      }
      this.updateLoading(true);
      this.$api.hcpInfo
        .postHcpInfo({
          ...this.hcp,
          EmployeePlant: EmployeePlant,
          EmployeeDepartment: EmployeeDepartment,
          BasicSalary: this.hcp.BasicSalary
            ? Number(this.hcp.BasicSalary.replace(/,/g, ""))
            : null,
          TransportationAllowance: this.hcp.TransportationAllowance
            ? Number(this.hcp.TransportationAllowance.replace(/,/g, ""))
            : null,
          ShiftAllowance: this.hcp.ShiftAllowance
            ? Number(this.hcp.ShiftAllowance.replace(/,/g, ""))
            : null,
          PerfectAttendanceBonus: this.hcp.PerfectAttendanceBonus
            ? Number(this.hcp.PerfectAttendanceBonus.replace(/,/g, ""))
            : null,
          OtherAllowance: this.hcp.OtherAllowance
            ? Number(this.hcp.OtherAllowance.replace(/,/g, ""))
            : null,
        })
        .then((response) => {
          if (response.status === 200) {
            this.closeModal();
            this.$notify({
              title: "成功",
              message: "儲存成功",
              type: "success",
              duration: 2500,
            });
            this.getHcp();
          }
          this.updateLoading(false);
        });
    },

    // 取得 HCP人事資料欄位
    getHcp() {
      this.updateLoading(true);
      this.$api.hcpInfo.getHcpInfo(this.personData.MatchId).then((response) => {
        if (response.status === 200) {
          this.hcp = response.data;
        }
        this.updateLoading(false);
      });
    },

    // 班別預設帶入資訊
    changeWorkShift() {
      const shift = this.shiftSources.filter(
        (item) => item.Guid === this.hcp.WorkShiftTypeGuid
      );
      if (shift.length > 0) {
        this.hcp.Food = shift[0].Food;
        this.hcp.PerfectAttendanceBonus =
          shift[0].PerfectAttendanceBonus === 0
            ? 0
            : this.$common.currencyThousands(
                String(shift[0].PerfectAttendanceBonus)
              );
        this.hcp.ShiftAllowance =
          shift[0].ShiftAllowance === 0
            ? 0
            : this.$common.currencyThousands(String(shift[0].ShiftAllowance));
        this.hcp.TransportationAllowance =
          shift[0].TransportationAllowance === 0
            ? 0
            : this.$common.currencyThousands(
                String(shift[0].TransportationAllowance)
              );
        this.hcp.OtherAllowanceName = "";
        this.hcp.OtherAllowance = 0;
      }
    },

    // 關閉 Modal
    closeModal() {
      this.hcp = {};
      this.$store.commit("OpenHcpDataModal", false);
    },

    async getData() {
      // 取得 部門
      const department = await this.$api.department.getDepartment();
      this.departmentOptions = department.data;
      // 取得 plant
      const plant = await this.$api.employeePlant.getPlant();
      this.plantOptions = plant.data.map((item) => {
        return {
          Guid: item.Guid,
          Name: item.Name,
        };
      });
      // 取得 班別
      const shift = await this.$api.workShift.getWorkShift();
      this.shiftSources = shift.data;
      this.shiftOptions = shift.data.map((item) => {
        return {
          Guid: item.Guid,
          Name: item.Name,
        };
      });
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  computed: {
    ...mapGetters(["showHcpData"]),
  },

  watch: {
    showHcpData: async function (newVal) {
      if (newVal) {
        this.getHcp();
        await $("#hcpModal").modal("show");
      } else {
        $("#hcpModal").modal("hide");
      }
    },

    // EmployeePlant
    "hcp.EmployeePlant": async function (newVal) {
      if (newVal && typeof newVal !== "string") {
        // 取得 EmployeeDepartment
        const dept = await this.$api.employeeDepartment.getEmployeeDepartment({
          EmployeePlantGuid: newVal.Guid,
        });
        this.deptOptions = dept.data.map((item) => {
          return {
            Guid: item.Guid,
            Name: item.Name,
          };
        });
      }
    },

    // 月薪
    "hcp.BasicSalary": function (newVal) {
      if (newVal) {
        this.hcp.BasicSalary = this.$common.currencyThousands(String(newVal));
      }
    },

    // 交通津貼
    "hcp.TransportationAllowance": function (newVal) {
      if (newVal) {
        this.hcp.TransportationAllowance = this.$common.currencyThousands(
          String(newVal)
        );
      }
    },

    // 班次津貼
    "hcp.ShiftAllowance": function (newVal) {
      if (newVal) {
        this.hcp.ShiftAllowance = this.$common.currencyThousands(
          String(newVal)
        );
      }
    },

    // 勤工營養金
    "hcp.PerfectAttendanceBonus": function (newVal) {
      if (newVal) {
        this.hcp.PerfectAttendanceBonus = this.$common.currencyThousands(
          String(newVal)
        );
      }
    },

    // 其他津貼
    "hcp.OtherAllowance": function (newVal) {
      if (newVal) {
        this.hcp.OtherAllowance = this.$common.currencyThousands(
          String(newVal)
        );
      }
    },
  },

  created() {
    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
    this.$store.commit("OpenHcpDataModal", false);
  },
};
</script>

<style lang="scss" scoped>
.radio-style {
  input {
    border: 1px solid #dcdfe6;
    cursor: pointer;
  }
  label {
    font-size: 14px;
    padding-left: 10px;
    color: #606266;
  }
}
</style>
